window.kaomiCartAdd = async function kaomiCartAdd(body) {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const sectionIds = Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
    .map((el) => el.dataset.sectionId)
    .filter(Boolean);

  let init;
  let lines;

  if (body instanceof FormData) {
    if (sectionIds.length) body.set('sections', sectionIds.join(','));
    lines = [{ merchandiseId: String(body.get('id')), quantity: Number(body.get('quantity')) || 1 }];
    init = { method: 'POST', body, headers: { Accept: 'application/json' } };
  } else {
    const payload = Object.assign({}, body);
    if (sectionIds.length) payload.sections = sectionIds.join(',');
    const items = payload.items || [{ id: payload.id, quantity: payload.quantity }];
    lines = items.map((i) => ({ merchandiseId: String(i.id), quantity: Number(i.quantity) || 1 }));
    init = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    };
  }

  const res = await fetch(root + 'cart/add.js', init);
  const data = await res.json();
  if (!res.ok || data.status) {
    throw new Error(data.description || data.message || 'Add to cart failed');
  }

  const cart = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());

  document.querySelectorAll('[data-cart-count]').forEach((badge) => {
    badge.textContent = cart.item_count;
    badge.classList.toggle('is-hidden', cart.item_count === 0);
  });
  document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart, item_count: cart.item_count } }));

  const drawer = document.querySelector('theme-drawer#cart-drawer');

  try {
    const { CartLinesUpdateEvent } = await import('@shopify/events');
    const deferred = CartLinesUpdateEvent.createPromise();
    document.dispatchEvent(
      new CartLinesUpdateEvent({ action: 'add', context: 'product', lines, promise: deferred.promise })
    );
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: {
        items: cart.items,
        sections: data.sections,
        source: 'kaomi-custom',
        itemCount: lines.reduce((sum, l) => sum + l.quantity, 0),
        didError: false,
      },
    });
    await deferred.promise;
  } catch (error) {
    console.warn('[kaomi] Could not refresh cart drawer, falling back to /cart:', error);
    window.location.href = root + 'cart';
    return data;
  }

  if (drawer && typeof drawer.open === 'function') {
    requestAnimationFrame(() => {
      if (!drawer.isOpen) drawer.open();
    });
  } else {
    window.location.href = root + 'cart';
  }

  return data;
};


/**
 * Kaomi Theme Custom JavaScript
 * Splide.js integration for Hero Banner Slider & Theme Interactions
 */

(function () {
  'use strict';

  /**
   * Initializes Splide.js for Kaomi Hero Banner
   * Autoplay is strictly OFF per design spec. Slides change only via arrows / swipe / drag.
   * Progress indicator tracks current slide position.
   */
  function initKaomiHeroSplide(root) {
  if (!root || !root.querySelectorAll) return;

  if (!window.Splide) {
    setTimeout(() => initKaomiHeroSplide(root), 100);
    return;
  }

  const splideElements = root.querySelectorAll(
    '.kaomi-hero-splide'
  );

  splideElements.forEach((splideEl) => {
    // Already initialized — don't recreate it.
    if (splideEl._splide) {
      return;
    }

    const slides = splideEl.querySelectorAll('.splide__slide');

    if (slides.length <= 1) return;

    const prevBtn = splideEl.querySelector('[data-hero-prev]');
    const nextBtn = splideEl.querySelector('[data-hero-next]');
    const progressBar = splideEl.querySelector('[data-hero-progress]');
    const progressTrack = splideEl.querySelector(
      '[data-hero-progress-track]'
    );

    const totalSlides = slides.length;

    const splide = new Splide(splideEl, {
      type: 'slide',
      perPage: 1,
      perMove: 1,

      autoplay: false,

      arrows: false,
      pagination: false,

      drag: true,
      snap: true,

      speed: 550,

      slideFocus: false,
      keyboard: false,

      // Prevent layout recalculation during movement
      waitForTransition: true,

      // Important for a single hero slider
      rewind: false,
    });

    // Store instance immediately
    splideEl._splide = splide;

    function updateProgress(index) {
      if (!progressBar) return;

      const progressHeight = 100 / totalSlides;

      progressBar.style.height = `${progressHeight}%`;
      progressBar.style.transform =
        `translate3d(0, ${index * 100}%, 0)`;

      if (progressTrack) {
        progressTrack.setAttribute(
          'aria-valuenow',
          String(index + 1)
        );
      }
    }

    splide.on('mounted', () => {
      updateProgress(splide.index);
    });

    splide.on('moved', (newIndex) => {
      updateProgress(newIndex);
    });

    // PREVIOUS
    if (prevBtn) {
      const prevHandler = (e) => {
        e.preventDefault();

        if (splide.state.is(Splide.STATES.MOVING)) return;

        splide.go('<');
      };

      prevBtn.addEventListener('click', prevHandler);

      prevBtn._heroPrevHandler = prevHandler;
    }

    // NEXT
    if (nextBtn) {
      const nextHandler = (e) => {
        e.preventDefault();

        if (splide.state.is(Splide.STATES.MOVING)) return;

        splide.go('>');
      };

      nextBtn.addEventListener('click', nextHandler);

      nextBtn._heroNextHandler = nextHandler;
    }

    // PROGRESS
    if (progressTrack) {
      const progressHandler = (e) => {
        const rect = progressTrack.getBoundingClientRect();

        if (!rect.height) return;

        const clickY = e.clientY - rect.top;

        const ratio = Math.max(
          0,
          Math.min(1, clickY / rect.height)
        );

        const targetIndex = Math.min(
          Math.floor(ratio * totalSlides),
          totalSlides - 1
        );

        if (targetIndex !== splide.index) {
          splide.go(targetIndex);
        }
      };

      progressTrack.addEventListener(
        'click',
        progressHandler
      );

      progressTrack._heroProgressHandler = progressHandler;
    }

    // Mount only once
    splide.mount();
  });
}

  /**
   * Initializes AJAX Add to Cart for Kaomi Featured Collection
   */
  function initKaomiShopAtc(root) {
    if (!root) return;

    const atcForms = root.querySelectorAll ? root.querySelectorAll('.kaomi-product-form') : [];
    atcForms.forEach((form) => {
      if (form._hasAtcListener) return;
      form._hasAtcListener = true;

      form.addEventListener('submit', async function (e) {
        e.preventDefault();
        const btn = form.querySelector('.kaomi-product-atc-btn');
        const textSpan = form.querySelector('.kaomi-atc-text');
        const originalText = textSpan ? textSpan.textContent.trim() : 'Add to Cart';

        const formData = new FormData(form);
        const variantId = formData.get('id');

        // Showcase / placeholder demo fallback
        if (!variantId || variantId === 'demo') {
          if (btn) btn.classList.add('is-loading');
          setTimeout(() => {
            if (btn) {
              btn.classList.remove('is-loading');
              btn.classList.add('is-success');
            }
            if (textSpan) textSpan.textContent = 'Added! ✓';
            setTimeout(() => {
              if (btn) btn.classList.remove('is-success');
              if (textSpan) textSpan.textContent = originalText;
            }, 2000);
          }, 350);
          return;
        }

        try {
          if (btn) {
            btn.disabled = true;
            btn.classList.add('is-loading');
          }
          if (textSpan) textSpan.textContent = 'Adding...';

                    await window.kaomiCartAdd(formData);

          if (btn) {
            btn.classList.remove('is-loading');
            btn.classList.add('is-success');
          }
          if (textSpan) textSpan.textContent = 'Added! ✓';

          setTimeout(() => {
            if (btn) {
              btn.disabled = false;
              btn.classList.remove('is-success');
            }
            if (textSpan) textSpan.textContent = originalText;
          }, 2000);

        } catch (error) {
          console.error('Cart add error:', error);
          if (btn) {
            btn.disabled = false;
            btn.classList.remove('is-loading');
          }
          if (textSpan) textSpan.textContent = 'Unavailable';
          setTimeout(() => {
            if (textSpan) textSpan.textContent = originalText;
          }, 2500);
        }
      });
    });
  }

  /**
   * Initializes Splide.js Carousel for Testimonials Video Cards
   */
  function initKaomiTestimonialsSplide(root) {
    if (!root) return;

    const splideElements = root.querySelectorAll
      ? root.querySelectorAll('.kaomi-testimonials-splide')
      : [];

    splideElements.forEach((splideEl) => {
      if (splideEl._splide) {
        splideEl._splide.destroy(true);
      }

      if (!window.Splide) {
        setTimeout(() => initKaomiTestimonialsSplide(root), 60);
        return;
      }

      const slides = splideEl.querySelectorAll('.splide__slide');
      if (slides.length === 0) return;

      const splide = new window.Splide(splideEl, {
        type: 'slide',
        perPage: 4,
        perMove: 1,
        gap: '40px',
        pagination: false,
        arrows: true,
        drag: true,
        speed: 500,
        breakpoints: {
          1440: {
            perPage: 3,
            gap: '30px',
          },
          1200: {
            perPage: 3,
            gap: '24px',
          },
          1024: {
            perPage: 2,
            gap: '20px',
          },
          768: {
            perPage: 2,
            gap: '16px',
          },
          480: {
            perPage: 1,
            gap: '14px',
          },
        },
      });

      // Pause any playing videos when sliding
      splide.on('move', () => {
        const playingCards = splideEl.querySelectorAll('.kaomi-testimonial-media-wrap.is-playing');
        playingCards.forEach((wrap) => {
          const video = wrap.querySelector('.kaomi-testimonial-video');
          if (video && !video.paused) {
            video.pause();
          }
          wrap.classList.remove('is-playing');
        });
      });

      splide.mount();
      splideEl._splide = splide;
    });
  }

  /**
   * Video & Poster Interaction Handler for Testimonials
   */
  function initKaomiTestimonialsVideo(root) {
    if (!root) return;

    const mediaWraps = root.querySelectorAll
      ? root.querySelectorAll('.kaomi-testimonial-media-wrap')
      : [];

    mediaWraps.forEach((wrap) => {
      if (wrap._hasVideoHandler) return;
      wrap._hasVideoHandler = true;

      const video = wrap.querySelector('.kaomi-testimonial-video');
      const playBtn = wrap.querySelector('[data-play-trigger]');
      const pauseBtn = wrap.querySelector('[data-pause-trigger]');

      function playVideo() {
        // Pause all other testimonial videos
        document.querySelectorAll('.kaomi-testimonial-media-wrap.is-playing').forEach((other) => {
          if (other !== wrap) {
            const otherVid = other.querySelector('.kaomi-testimonial-video');
            if (otherVid && !otherVid.paused) {
              otherVid.pause();
            }
            other.classList.remove('is-playing');
          }
        });

        wrap.classList.add('is-playing');
        if (video) {
          const playPromise = video.play();
          if (playPromise !== undefined) {
            playPromise.catch(() => {
              // Browser policy fallback: mute and play
              video.muted = true;
              video.play().catch(() => {});
            });
          }
        }
      }

      function pauseVideo() {
        wrap.classList.remove('is-playing');
        if (video && !video.paused) {
          video.pause();
        }
      }

      if (playBtn) {
        playBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          playVideo();
        });
      }

      if (pauseBtn) {
        pauseBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          pauseVideo();
        });
      }

      // Clicking video card when playing toggles pause
      wrap.addEventListener('click', (e) => {
        if (e.target.closest('[data-play-trigger]') || e.target.closest('[data-pause-trigger]')) return;
        if (wrap.classList.contains('is-playing')) {
          pauseVideo();
        } else {
          playVideo();
        }
      });

      // Restore poster if video finishes
      if (video) {
        video.addEventListener('ended', () => {
          wrap.classList.remove('is-playing');
        });
      }
    });
  }

  /**
   * Initialize on DOM readiness
   */
  function initAll() {
    initKaomiHeroSplide(document);
    initKaomiShopAtc(document);
    initKaomiTestimonialsSplide(document);
    initKaomiTestimonialsVideo(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify Theme Editor Lifecycle Events
  document.addEventListener('shopify:section:load', (e) => {
    initKaomiHeroSplide(e.target);
    initKaomiShopAtc(e.target);
    initKaomiTestimonialsSplide(e.target);
    initKaomiTestimonialsVideo(e.target);
  });

  document.addEventListener('shopify:section:unload', (e) => {
    const splideHero = e.target.querySelector('.kaomi-hero-splide');
    if (splideHero && splideHero._splide) {
      splideHero._splide.destroy(true);
      splideHero._splide = null;
    }

    const splideTestimonials = e.target.querySelector('.kaomi-testimonials-splide');
    if (splideTestimonials && splideTestimonials._splide) {
      splideTestimonials._splide.destroy(true);
      splideTestimonials._splide = null;
    }
  });

  document.addEventListener('shopify:block:select', (e) => {
    const slide = e.target.closest('.splide__slide');
    if (slide && slide.dataset.slideIndex !== undefined) {
      const splideEl = slide.closest('.kaomi-hero-splide, .kaomi-testimonials-splide');
      if (splideEl && splideEl._splide) {
        const index = parseInt(slide.dataset.slideIndex, 10);
        splideEl._splide.go(index);
      }
    }
  });
})();
